import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Dialog.scss';

import ReactModal from 'react-modal';

export default class Dialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        shouldCloseOnOverlayClick: PropTypes.bool,
        dialogClassName: PropTypes.any,
        bodyClassName: PropTypes.string,
        children: PropTypes.any,
        onClose: PropTypes.func.isRequired,
        isLong: PropTypes.bool,
        preloadBg: PropTypes.bool
    };

    static defaultProps = {
        visible: true,
        shouldCloseOnOverlayClick: true
    };

    render() {
        const {
            visible,
            shouldCloseOnOverlayClick,
            dialogClassName,
            children,
            onClose,
            isLong,
            bodyClassName,
            preloadBg
        } = this.props;

        const className = classNames(dialogClassName, styles.dialog);
        const wrapper = classNames(styles.contentWrapper, bodyClassName, isLong ? styles.long : '', preloadBg ? styles.preloadBg : '');

        return (
            <ReactModal isOpen={visible}
                        overlayClassName={styles.overlay}
                        className={className}
                        contentLabel=''
                        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                        onRequestClose={onClose}>
                <div className={styles.closeButton}
                     onClick={onClose}></div>
                <div className={wrapper}>
                    {children}
                </div>
            </ReactModal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/dialogs/ComponentDialog.js